import React, { useMemo, useState } from 'react';
import { fmt } from '../lib/formato';

function CalendarView({ leads, onOpenLead }) {
  const [ref, setRef] = useState(() => { const d = new Date(); d.setDate(1); d.setHours(0,0,0,0); return d; });
  const [campo, setCampo] = useState('next_contact_date');

  const CAMPOS = [
    { key:'next_contact_date', label:'Próxima abordagem' },
    { key:'forecast_date',     label:'Previsão de fechamento' },
  ];

  const hoje = new Date(); hoje.setHours(0,0,0,0);
  const ano = ref.getFullYear(), mes = ref.getMonth();
  const primeiroDia = new Date(ano, mes, 1).getDay();
  const diasNoMes   = new Date(ano, mes + 1, 0).getDate();

  // agrupa os leads por dia do mês
  const porDia = useMemo(() => {
    const mapa = {};
    for (const l of leads) {
      const v = l[campo];
      if (!v || ['fechado','perdido'].includes(l.stage)) continue;
      const d = new Date(v + 'T00:00:00');
      if (d.getFullYear() !== ano || d.getMonth() !== mes) continue;
      (mapa[d.getDate()] ||= []).push(l);
    }
    return mapa;
  }, [leads, campo, ano, mes]);

  const totalMes = Object.values(porDia).reduce((s, ls) => s + ls.length, 0);
  const valorMes = Object.values(porDia).flat().reduce((s, l) => s + (Number(l.value) || 0), 0);
  const mover = (n) => setRef(d => new Date(d.getFullYear(), d.getMonth() + n, 1));
  const nomeMes = ref.toLocaleDateString('pt-BR', { month:'long', year:'numeric' });

  const celulas = [];
  for (let i = 0; i < primeiroDia; i++) celulas.push(null);
  for (let d = 1; d <= diasNoMes; d++) celulas.push(d);

  return <div className="flex flex-col gap-4">
    <div className="flex items-center justify-between gap-3 flex-wrap">
      <h2 className="text-lg font-bold text-gray-800">Calendário</h2>
      <div className="flex items-center gap-2 flex-wrap">
        <select className="apple-input px-3 py-2 text-sm" value={campo} onChange={e=>setCampo(e.target.value)}>
          {CAMPOS.map(c=><option key={c.key} value={c.key}>{c.label}</option>)}
        </select>
        <div className="flex items-center gap-1">
          <button onClick={()=>mover(-1)} aria-label="Mês anterior"
            className="tap-safe w-9 h-9 flex items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-500 hover:border-gray-300 transition-colors">‹</button>
          <button onClick={()=>{const d=new Date();d.setDate(1);d.setHours(0,0,0,0);setRef(d);}}
            className="text-sm px-3 py-2 rounded-xl border border-gray-200 bg-white text-gray-600 hover:border-gray-300 transition-colors">Hoje</button>
          <button onClick={()=>mover(1)} aria-label="Próximo mês"
            className="tap-safe w-9 h-9 flex items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-500 hover:border-gray-300 transition-colors">›</button>
        </div>
      </div>
    </div>

    <div className="flex items-center gap-4 flex-wrap">
      <span className="t-headline font-semibold text-gray-900 capitalize">{nomeMes}</span>
      <span className="text-sm text-gray-400">
        {totalMes} lead{totalMes!==1?'s':''}{valorMes>0 ? ` · ${fmt(valorMes)}` : ''}
      </span>
    </div>

    <div className="acard rounded-2xl p-3">
      <div className="grid grid-cols-7 gap-1 mb-1">
        {['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'].map(d=>(
          <div key={d} className="t-caption-2 text-gray-400 font-medium text-center py-1">{d}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {celulas.map((dia, i) => {
          if (dia === null) return <div key={`v${i}`} className="min-h-[92px]" />;
          const data = new Date(ano, mes, dia);
          const doDia = porDia[dia] || [];
          const ehHoje = data.getTime() === hoje.getTime();
          const atrasado = data < hoje && doDia.length > 0;
          return (
            <div key={dia} className={`min-h-[92px] rounded-xl p-1.5 border transition-colors ${
              ehHoje ? 'border-blue-400 bg-blue-50/60'
              : atrasado ? 'border-red-200 bg-red-50/50'
              : doDia.length ? 'border-gray-200 bg-white' : 'border-transparent bg-black/[0.02]'}`}>
              <div className={`t-caption-2 font-semibold mb-1 ${ehHoje ? 'text-blue-600' : atrasado ? 'text-red-500' : 'text-gray-400'}`}>
                {dia}
              </div>
              <div className="space-y-0.5">
                {doDia.slice(0,3).map(l=>(
                  <button key={l.id} onClick={()=>onOpenLead(l)}
                    title={`${l.company_name}${l.value>0?' · '+fmt(l.value):''}`}
                    className="w-full text-left t-caption-2 px-1.5 py-1 rounded-lg bg-blue-100/70 text-blue-800 hover:bg-blue-200 transition-colors truncate">
                    {l.company_name}
                  </button>
                ))}
                {doDia.length > 3 && (
                  <span className="block t-caption-2 text-gray-400 px-1.5">+{doDia.length-3} mais</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>

    {totalMes === 0 && (
      <p className="text-sm text-gray-400 text-center py-6">
        Nenhum lead com {CAMPOS.find(c=>c.key===campo).label.toLowerCase()} neste mês.
      </p>
    )}
  </div>;
}

// ─── RepAssesView ─────────────────────────────────────────

export { CalendarView };
